export default __webpack_public_path__ + "images/d6f875c95eefcf40ff7f38ff39cd1513-connect.svg";